import { getZmpConfig } from '@/common/provider/zmp.config';
import { readLocalStorageValue } from '@mantine/hooks'
import axios from 'axios'
import { getStorefrontStorageKey } from '@/common/storefront/storefront.config'

const httpClient = axios.create({
  baseURL: import.meta.env.VITE_APP_API,
  headers: {
    "Content-Type": "application/json",
    deviceCode: 'web'
  }
})

httpClient.interceptors.request.use(async (config) => {
  const zmpConfig = await getZmpConfig()

  const oodId = readLocalStorageValue<{ 
    access_token: string
    refresh_token: string
  }>({ key: "ood_id.user" })

  const cartStore = readLocalStorageValue<{
    state: {
      core: {
        order_meta: {
          trainCode: string
        }
      }
    }
  }>({ key: getStorefrontStorageKey('cart-storage') })

  const trainCode = cartStore?.state?.core?.order_meta?.trainCode

  config.headers['BrandCode'] = zmpConfig.brandCode || ''
  config.headers['TrainCode'] = trainCode

  if (oodId) {
    config.headers.Authorization = `Bearer ${oodId?.access_token}` // Sử dụng access_token từ oodId
  } else {
    delete config.headers.Authorization // Xóa nếu không có token
  }

  return config
});

// Interceptor: Xử lý lỗi 401 (Unauthorized)
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized (401): Clearing accessToken...")
      localStorage.removeItem("ood_id.user")
      window.dispatchEvent(new Event("logout"))
    }

    return Promise.reject(error instanceof Error ? error : new Error(error?.message || 'Unknown error'))
  }
);

export default httpClient
